// ============================================================
// definitions.nav.ts — Phase-4 migration descriptor
// ------------------------------------------------------------
// Component-free, data-only navigation descriptor for the Admin
// Definitions group (Device types / Firmware). Imports ONLY pure
// types/constants (@twist/ui-navigation types + @twist/core security
// primitives) — no component / feature code — so the registry stays a
// pure data graph.
//
// Mirrors the legacy sideNavConfig "Admin › Definitions" group: the
// group-parent + every sub-item are gated TWIST_ADMIN_ONLY
// (orgTypes: [TwistAdmin]) — identical to the legacy group constraint.
//
// Whole-group migration: the children carry the `sidebar` surface so the
// legacy "Definitions" group de-dups out (every sub-item path is
// piloted). Both paths are live routes under HARDWARE_BUILDUP_ROUTES. The
// registry projects this as a SINGLE top-level "Definitions" leaf
// (→ /hardware-buildup/devices).
// ============================================================
import { TWIST_ADMIN_ONLY } from '@twist/core';
import type { NavDescriptor } from '@twist/ui-navigation';

export const definitionsNav: NavDescriptor = {
  id: 'definitions',
  path: '/hardware-buildup/devices',
  label: 'Definitions',
  icon: 'gearsDatabase',
  group: 'Admin',
  // Admin section = 40s; Definitions second (after Manufacturing hub).
  order: 41,
  surfaces: ['sidebar', 'palette'],
  security: TWIST_ADMIN_ONLY,
  children: [
    {
      id: 'definitions-device-types',
      path: '/hardware-buildup/devices',
      label: 'Device types',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
    {
      id: 'definitions-firmware',
      path: '/hardware-buildup/firmware',
      label: 'Firmware',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
  ],
};
